/**
 * ¿Deadline vencido o lock manual? Mensajes y override de admin en el cliente.
 */

/** Timestamp Firestore / ISO → Date o null. */
export function parseDeadlineDate(timestamp) {
    if (!timestamp) return null;
    let date;
    if (timestamp.toDate && typeof timestamp.toDate === 'function') {
        date = timestamp.toDate();
    } else if (timestamp._seconds !== undefined) {
        date = new Date(timestamp._seconds * 1000);
    } else if (timestamp.seconds !== undefined) {
        date = new Date(timestamp.seconds * 1000);
    } else {
        date = new Date(timestamp);
    }
    return Number.isNaN(date.getTime()) ? null : date;
}

/** true si el deadline del reporte ya pasó. */
export function isPastApprovalDeadline(report) {
    const deadline = parseDeadlineDate(report?.approvalDeadline);
    return !!(deadline && deadline.getTime() < Date.now());
}

/** true si un admin bloqueó la aprobación a mano. */
export function isManualApprovalLock(report) {
    return report?.approvalLocked === true;
}

/** true si el checkbox no debe editarse por lock manual (salvo admin). */
export function isApprovalFrozen(report) {
    return isManualApprovalLock(report);
}

export function isFullyApprovedStatus(status) {
    return status === 'complete' || status === 'complete_late';
}

export function approvalStatusLabel(status) {
    if (status === 'complete_late') return 'Aprobado con retrasos';
    if (status === 'complete') return 'Aprobado';
    if (status === 'overdue') return 'Vencido';
    if (status === 'pending') return 'Pendiente';
    return status || '—';
}

/** rol admin o permiso reports_lock_approval. */
export function canOverrideApprovalLock(userRole, userPermissions) {
    return userRole === 'admin' || userPermissions?.reports_lock_approval === true;
}

/** Texto de UI para el freeze o el aviso de tardía, o cadena vacía. */
export function approvalLockMessage(report) {
    if (report?.approvalLocked === true) {
        return 'Aprobación bloqueada por un administrador.';
    }
    if (isPastApprovalDeadline(report)) {
        return 'El deadline venció. Aún puedes aprobar; se registrará como aprobación tardía.';
    }
    return '';
}
